// PayModeView.jsx

import { GetValuesRender } from './commonViews';

import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

const PayModeView = props => {
    const { data } = props;

    const { paymentModeDetails } = data;

    // remove paymentModeDetails
    const simpleFields = (({ paymentModeDetails, ...rest }) => rest)(data);

    return (
        <>
            <div className="checker-section-container">
                <h1 className="checker-section-title">
                    Payment Mode Section Data
                </h1>
                <div className="form-section allow-overflow">
                    <PaymentTable paymentModeDetails={paymentModeDetails} />
                </div>
                <div className="form-section">
                    <GetValuesRender
                        data={simpleFields}
                        isNestedRenderingAllowed
                    />
                </div>
            </div>
        </>
    );
};

PayModeView.propTypes = {
    data: PropTypes.object,
};

const PaymentTable = ({ paymentModeDetails }) => {
    return (
        <div>
            <table>
                <thead>
                    <tr>
                        <th>Payment Type</th>
                        <th>Payment Mode Info</th>
                        <th>Payment Mode Info UI</th>
                        <th>Payment Sub Mode Info</th>
                        <th>Business Source</th>
                        <th>Account Type</th>
                        <th>Category</th>
                    </tr>
                </thead>
                <tbody>
                    {paymentModeDetails.map((item, index) => (
                        <tr key={index}>
                            <td>{item.paymentType}</td>
                            <td>{item.paymentModeInfo}</td>
                            <td>{item.paymentModeInfoUI || '-'}</td>
                            <td>{item.paymentSubModeInfo || '-'}</td>
                            <td>
                                {isEmpty(item.txnConfig) ? (
                                    <span>-</span>
                                ) : (
                                    item.txnConfig.map(
                                        (config, configIndex) => (
                                            <span key={configIndex}>
                                                {config.businessSource}
                                                {configIndex ===
                                                item.txnConfig.length - 1
                                                    ? ' '
                                                    : ', '}
                                            </span>
                                        )
                                    )
                                )}
                            </td>
                            <td>
                                {item &&
                                item.txnConfig &&
                                item.txnConfig[0].accountType
                                    ? item.txnConfig[0].accountType.join(', ')
                                    : '-'}
                            </td>
                            <td>{item.category || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

PaymentTable.propTypes = {
    paymentModeDetails: PropTypes.object,
};

export default PayModeView;
